<template>
  <div>
    <lgg-top></lgg-top>
    <div>
      <v-parallax height="550" src="@/img/b001.jpg"></v-parallax>
    </div>

    <div style="display:flex; justify-content: space-between; width: 1020px; margin: 100px auto; ">
      <lgg-title fubiaoti="实力·认证" color="dodgerblue" width="470px">
        TECHNLOGIES<br>CERTIFICATION
      </lgg-title>


      <div style="width:480px; display:flex; justify-content:space-between;">
        <div style=" margin:0 auto;">
          <p class="xiwen" style="text-align: justify;text-justify: newspaper;word-break: break-all;">
            公司通过了ISO9001质量管理体系，FSC/COC森林管理委员会/产销键关联体系认证，ICTI国际玩具协会认证，集团具有广泛的知名度和较大的影响力，公司拥有国际先进的印刷设备机群以及自动化程度较高的后加工及包装设备，2008年通过政府招商引资落户宿迁，并于2011年在经济开发区金陵南路168号兴建厂房12000平方米，公司占地面积60余亩，现有员工160余人。</p>
          <br><img src="@/img/ICON3.png">
        </div>
      </div>
    </div>

    <div>
      <v-parallax src="@/img/b002.jpg" height="550"></v-parallax>
    </div>


    <div style="display:flex; justify-content: space-between; width: 1020px; margin: 100px auto; ">

      <lgg-title fubiaoti="好产品高品质" color="yellow" width="350px">
        MAKE HIGH<br>QUALITY<br>PRODUCTS
      </lgg-title>

      <div style="width:480px; display:flex; justify-content:space-between;">
        <div style=" margin:0 auto;">
          <h3>业务范围</h3>
          <p class="xiwen" style=" text-align: justify;text-justify: newspaper;word-break: break-all;">
            公司经营产品多元化﹐包括有彩咭﹑贴纸﹑3D立体胶片﹑贺卡、PDQ(展示盒)、彩色印盒制品等。并提供专业化的包装定制、组装以及出口服务，根据客户的要求提供创意设计、创新研发、一体化制造、自动化大规模生产以及就近快捷交付等专业服务，主要出口欧美、澳洲等国家，从2012年开始提供印刷包装品组装服务至今，尤其是生产彩色鞋盒，组装包装鞋子、围巾、帽子等特色服务，得到欧美各类著名品牌厂家的大力认可，我们在生产、包装等环节不断创新、改革、引用新技术，从包装鞋子用的实木熏蒸托盘到现在的环保纸托盘的这一技术变更，不但节省了客户的成本，也更加环保，既能轻松的装卸，又能节省空间，在运输方面做到了产品运输空间的最大化，同样也为客户节省了大笔的运输费用。
          </p>
        </div>
      </div>
    </div>

    <div style=" width: 100%; top: 0; left: 0 ">
      <div style="width: 1920px; display:flex; justify-content:space-between; align-items:center; margin:0px auto; ">
        <img style="background:rgba(255,255,255,0.5)" src="../img/guangao03.png">
        <img style="background:rgba(255,255,255,0.5)" src="../img/guangao04.png">
        <img style="background:rgba(255,255,255,0.5)" src="../img/guangao05.png">
      </div>
    </div>

    <div style="display:flex; justify-content: space-between; width: 1020px; margin: 100px auto; ">
      <lgg-title fubiaoti="全球化服务" color="#ff00ff" width="300px">
        GLOBAL<br>SERVICES
      </lgg-title>

      <div style="width:480px; display:flex; justify-content:space-between;">
        <div style=" margin:0 auto;">
          <h4>业务范围</h4>
          <p class="xiwen" style=" text-align: justify;text-justify: newspaper;word-break: break-all;">
            跨越不同的行业与领域、产品与服务、国家与文化，
            我们始终协助客户构建强大有力的产品包装，并不断创新改变。 </p>
          <br><img src="@/img/ICON4.png">
        </div>
      </div>
    </div>

    <div>
      <v-parallax src="@/img/b003.jpg" height="550"></v-parallax>
    </div>
<lgg-diwen></lgg-diwen>
  </div>
</template>

<script>
import LggTop from "@/components/lgg-top";
import lggTitle from '@/components/lgg-title.vue'
import LggDiwen from "@/components/lgg-diwen";

export default {
  name: 'About',
  components: {LggDiwen, lggTitle, LggTop}
}
</script>
<style scoped>
.xiwen {
  font-size: 15px;
  font-weight: lighter;
  line-height: 30px;
}


</style>
